import { createClient } from "@sanity/client"
import type { SanityClient } from "@sanity/client"

export const SANITY_API_VERSION = "2024-01-01"

/** In dev, browser GROQ uses `/sanity-proxy` (see vite.config.ts) so requests stay same-origin. Set `VITE_SANITY_DISABLE_PROXY=true` to use the CDN URL directly (needs CORS in Sanity Manage). */
export function use_sanity_dev_proxy(): boolean {
  return (
    import.meta.env.DEV &&
    import.meta.env.MODE !== "test" &&
    typeof window !== "undefined" &&
    import.meta.env.VITE_SANITY_DISABLE_PROXY !== "true"
  )
}

export function getSanityProjectId(): string | undefined {
  return import.meta.env.VITE_SANITY_PROJECT_ID as string | undefined
}

export function getSanityDataset(): string | undefined {
  return import.meta.env.VITE_SANITY_DATASET as string | undefined
}

export function createSanityBrowserClient(): SanityClient | null {
  const projectId = getSanityProjectId()
  const dataset = getSanityDataset()
  if (!projectId || !dataset) {
    return null
  }
  return createClient({
    projectId,
    dataset,
    apiVersion: SANITY_API_VERSION,
    // Must use CDN for browser: `api.sanity.io` (useCdn: false) is not CORS-enabled for in-browser public GROQ and returns 403 from localhost.
    useCdn: true,
  })
}
